<template>
  <modal 
    name="change-card-modal" 
    :pivotY="0.2"
    :height="'auto'"
    width="90%" :maxWidth="550" :adaptive="true"
    @before-open="beforeOpen"
    @opened="opened">
    
    <div class="modal-header">
      <div class="modal-title">
        Please type in your new card details
      </div>

      <a href="#"
        v-on:click.prevent="$modal.hide('change-card-modal')"
        class="text-gray-500 hover:text-gray-600">
        <svg width="20" height="20" stroke-width="2" class="align-middle" stroke="currentColor" fill="none">
          <use xlink:href="/static/img/feather-sprite.svg#x-circle"/>
        </svg>
      </a>
    </div>
    
    <div class="modal-body">

      <label class="label-standard">Name on credit card</label>

      <div class="form-line">
        <input type="text" v-model="cardHolderName" class="input-standard">
      </div>

      <div class="label-line">
        <label class="label-standard">Credit card details</label>
      </div>

      <div class="form-line">
        <card class='stripe-card'
          ref="cardNumber"
          :class='{ complete }'
          :stripe='getStripeKey'
          :options='stripeOptions'
          @change='complete = $event.complete' />
      </div>

      <template v-if="error != null">
        <div class="text-red-600 mt-2 text-sm">
          {{ error.message }}
        </div>
      </template>

      <div class="mt-8 text-left">
        <SubmitButton label="Update" v-bind:onClick="submit" v-bind:loading="loading"></SubmitButton>
      </div>
    </div>
  </modal>
</template>

<script>
  import axios        from 'axios'
  import moment       from 'moment'
  import { EventBus } from '@/shared/event-bus'
  import SubmitButton from '@/shared/components/form/SubmitButton'

  import { 
    Card, 
    createToken, 
    instance, 
    cardNumber 
  } from 'vue-stripe-elements-plus'

  export default {

    components : {
      Card,
      SubmitButton
    },

    props : {
      broker : {
        type    : Object,
        required: false
      }
    },

    data() {
      return {
        error         : null,
        intent        : null,
        loading       : false,
        cardHolderName: null,
        complete      : false,
        stripeOptions : {
          hidePostalCode : true
        }
      }
    },

    methods : {

      beforeOpen(event) {
        this.error = null
      },

      opened() {
        this.apiGet({}, 'stripe/intent', (intent) => {
          this.intent = intent
        })
      },

      async submit() {

        this.error = null

        // createToken returns a Promise which resolves in a result object with
        // either a token or an error key.
        // See https://stripe.com/docs/api#tokens for the token object.
        // See https://stripe.com/docs/api#errors for the error object.
        // More general https://stripe.com/docs/stripe.js#stripe-create-token.
        // createToken().then(data => {
        //   console.log(data.token)
        // })

        const { setupIntent, error } = await instance.handleCardSetup(
          this.intent.client_secret,
          // this dirty hack, but still it could be used to get access to the Stripe element
          // this.$refs.cardNumber is a reference to already mounted cardNumber component
          this.$refs.cardNumber.$refs.element._element, 
          {
            payment_method_data: {
              billing_details: {
                name: this.cardHolderName
              }
            }
          }
        )

        if (error) {
          this.error = error
        } else {
          
          // we can now subscribe the user
          this.loading = true

          let params = {
            paymentMethod: setupIntent.payment_method,
          }

          axios.post(process.env.VUE_APP_API_URL + '/api/stripe/change-card', params, {
            headers : {
              'Authorization' : 'Bearer ' + localStorage.getItem('bp-broker-jwt')
            }
          }).then(response => {
            this.loading = false

            if(response.data != null && response.data.error != null) {
              this.error = {
                message : "There was an error with your card."
              }
            }

            else {
              this.$modal.hide('change-card-modal')
              EventBus.$emit('notification-event', {
                'type'   : 'success',
                'message': "Card updated successfully"
              })
            }

          }).catch(e => {
            this.loading = false
            this.error = {
              message : "There was an error with your card."
            }
          })

        }
      },
    }
  }
</script>

<style>
/**
 * The CSS shown here will not be introduced in the Quickstart guide, but shows
 * how you can use CSS to style your Element's container.
 */
.StripeElement {
  border: 1px solid #8E9193;
  padding: 10px 12px;
  box-shadow: 0 1px 3px 0 #e6ebf1;
  -webkit-transition: box-shadow 150ms ease;
  transition: box-shadow 150ms ease;

  /*box-sizing: border-box;

  height: 40px;

  

  
  border-radius: 4px;
  background-color: white;

*/
}

.StripeElement--focus {
  box-shadow: 0 1px 3px 0 #cfd7df;
}

.StripeElement--invalid {
  border-color: #fa755a;
}

.StripeElement--webkit-autofill {
  background-color: #fefde5 !important;
}
</style>